import useIsInappWebview from "./useIsInappWebview";
import useGetDeviceInfo from "./useGetDeviceInfo";
import { compareVersions } from "../logic/logics_common";

export default function useIsTabExists() {
  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();

  return (
    !isInappWebview ||
    (isInappWebview && compareVersions(appVersion, "1.1.28") >= 0)
  );
}
